import React from 'react'

export const MoreIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00016 1.83337C11.4055 1.83337 14.1668 4.59404 14.1668 8.00004C14.1668 11.4054 11.4055 14.1667 8.00016 14.1667C4.59416 14.1667 1.8335 11.4054 1.8335 8.00004C1.8335 4.59471 4.59483 1.83337 8.00016 1.83337Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6262 8.00863H10.6322"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.95387 8.00863H7.95987"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.28102 8.00863H5.28702"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
